module.exports = __webpack_public_path__ + "media/home_page_video01.9b154bfc.mp4";